import React from 'react';
import './SentimentFace.scss';
import { Icon } from '@cx/ui';

const icons: { [key: string]: string } = {
  Positive: 'smile',
  Negative: 'sad',
  Neutral: 'neutral',
};

const colors: { [key: string]: string } = {
  Positive: '#6BBE0B',
  Negative: '#992E65',
  Neutral: '#CCCCCC',
};

interface SentimentFaceProps {
  sentiment: string;
  size?: number;
}

function SentimentFace({ sentiment, size = 30 }: SentimentFaceProps) {
  if (!sentiment || sentiment === 'Neutral') return null;
  return (
    <div
      className={`sentiment-container ${sentiment.toLowerCase()}`}
      style={{
        height: size,
        width: size,
      }}
    >
      <Icon name={icons[sentiment]} size={size} color={colors[sentiment]} />
    </div>
  );
}

export default SentimentFace;
